import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useChatWindow } from '../../App';
import Button from '../ui/Button';


const MessageButton = ({ className = '', userSub, recipientName }) => {
  const { isAuthenticated, accountReady } = useAuth();
  const { openChatWithUser } = useChatWindow();
  const navigate = useNavigate();

  const handleClick = () => {
    if (!isAuthenticated) {
      navigate('/login-prompt');
    } else if (accountReady === false) {
      navigate(`/messages?conversation=${encodeURIComponent(userSub)}`);
    } else {
      openChatWithUser(userSub, null, recipientName);
    }
  };

  return (
    <Button
      variant="primary"
      size="md"
      onClick={handleClick}
      className={`message-button ${className}`}
    >
      Message
    </Button>
  );
};

export default MessageButton;